export function isNumberNaN(num) {
  if (Number.isNaN) {
    return Number.isNaN(num);
  }
  // eslint-disable-next-line no-self-compare
  return num !== num;
}
